"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollHeight = void 0;
const react_1 = require("react");
function useScrollHeight(ref) {
    const [scrollHeight, setScrollHeight] = react_1.useState(0);
    react_1.useLayoutEffect(() => {
        const newScrollHeight = !ref.current ? 0 : ref.current.scrollHeight || 0;
        if (scrollHeight !== newScrollHeight) {
            setScrollHeight(newScrollHeight);
        }
    });
    return scrollHeight;
}
exports.useScrollHeight = useScrollHeight;
//# sourceMappingURL=useScrollHeight.js.map